import { get, protectedGet } from "./restUtil";

const LANGUAGES_OBJ_NAME = "Talaera_native_languages";

export function getConfiguration(onSuccess, onError) {
  return protectedGet("/configuration", undefined, onSuccess, onError);
}

export function getFirebaseConfig(onSuccess, onError) {
  return protectedGet("/configuration/firebase", undefined, onSuccess, onError);
}

export function getAWSConfig() {
  return new Promise((resolve, reject) => {
    protectedGet("/configuration/aws", undefined, resolve, reject);
  });
}

export function getLanguages(args, onSuccess, onError) {
  let languagesObj = localStorage.getItem(LANGUAGES_OBJ_NAME);
  languagesObj = languagesObj ? JSON.parse(languagesObj) : null;
  if (!languagesObj || new Date().getTime() - languagesObj.time > 5 * 60 * 1000) {
    protectedGet(
      "/configuration/languages",
      undefined,
      resp => {
        localStorage.setItem(
          LANGUAGES_OBJ_NAME,
          JSON.stringify({
            time: new Date().getTime(),
            languages: resp,
          })
        );
        return onSuccess && onSuccess(resp);
      },
      onError
    );
  } else {
    return onSuccess && onSuccess(languagesObj.languages);
  }
}

export function getOnboardingLanguages(onSuccess, onError) {
  get(
    "/configuration/languages",
    null,
    resp => {
      return onSuccess(resp);
    },
    onError
  );
}
